import {centsToLocalizedString, toCentsFromMoney} from "../../../../../lib/Money.ts";
import {formatDeltaPercent, isWithinDeltaDeadBand} from "../../utils";
import {type ViewRow} from "../../types";
import {AmountCell} from "./AmountCells.tsx";
import {
    COL_SEP_L,
    COLOR_NEGATIVE,
    COLOR_POSITIVE,
    isBlankedHeader,
    signColorClass,
} from "./tableStyles.ts";
import type {SbsSection} from "../../../../../generated/enums.ts";

function deltaColor(
    ratio: number | null,
    growthIsFavourable: boolean | null,
): string {
    if (isWithinDeltaDeadBand(ratio) || growthIsFavourable === null) {
        return "text-gray-400";
    }
    const grew = ratio! > 0;
    return grew === growthIsFavourable ? COLOR_POSITIVE : COLOR_NEGATIVE;
}

export function ComparisonCells({
    row,
    sectionKind,
    isSlim,
}: {
    row: ViewRow;
    sectionKind: SbsSection;
    isSlim: boolean;
}) {
    const blank = isBlankedHeader(row) || row.comparison === null;
    const signed = blank ? 0 : toCentsFromMoney(row.comparison!.signed_net);
    const currentSigned = blank ? 0 : toCentsFromMoney(row.signed_net);
    const deltaRatio = blank ? null : row.comparison!.delta_ratio;
    const isProfitAndLoss = sectionKind === 'profit_and_loss';
    const movementColor = isProfitAndLoss
        ? deltaColor(deltaRatio, row.growth_is_favourable)
        : "text-gray-700";
    const withArrow = !isProfitAndLoss;

    if (isSlim) {
        if (blank) {
            return (
                <>
                    <td className={`px-3 py-2 ${COL_SEP_L}`} />
                    <td className="px-3 py-2" />
                </>
            );
        }
        return (
            <>
                <td
                    className={`px-3 py-2 text-right text-[13px] tabular-nums whitespace-nowrap ${COL_SEP_L} ${signColorClass(signed)}`}
                >
                    {centsToLocalizedString(Math.abs(signed))}
                </td>
                <td className="px-3 py-2 text-right text-[13px] tabular-nums whitespace-nowrap">
                    <span className={movementColor}>
                        {formatDeltaPercent(deltaRatio, currentSigned, signed, withArrow)}
                    </span>
                </td>
            </>
        );
    }

    const debitCents = signed < 0 ? Math.abs(signed) : 0;
    const creditCents = signed > 0 ? signed : 0;
    return (
        <>
            <td className={`px-3 py-2 text-right tabular-nums ${COL_SEP_L}`}>
                {blank ? null : <AmountCell cents={debitCents} />}
            </td>
            <td className="px-3 py-2 text-right tabular-nums">
                {blank ? null : <AmountCell cents={creditCents} />}
            </td>
            <td className="px-3 py-2 text-right tabular-nums">
                {blank ? null : (
                    <span className={`text-[13px] ${movementColor}`}>
                        {formatDeltaPercent(deltaRatio, currentSigned, signed, withArrow)}
                    </span>
                )}
            </td>
        </>
    );
}
